import api from '../utils/api';

const analyticsService = {
  getStudentAnalytics: (studentId, academicTermId) => api.get(`/api/analytics/student/${studentId}`, { params: { academic_term_id: academicTermId } }),
  getClassAnalytics: (classId, academicTermId) => api.get(`/api/analytics/class/${classId}`, { params: { academic_term_id: academicTermId } }),
  getAtRiskStudents: (academicTermId) => api.get('/api/analytics/at-risk', { params: { academic_term_id: academicTermId } }),
  getClassComparison: (academicTermId) => api.get('/api/analytics/class-comparison', { params: { academic_term_id: academicTermId } }),
  recalculateAll: (academicTermId) => api.post('/api/analytics/calculate-all', null, { params: { academic_term_id: academicTermId } }),
};

export default analyticsService;
